export class Debugger {
  private enabled = false;

  public enable(): void {
    this.enabled = true;
  }

  public disable(): void {
    this.enabled = false;
  }

  public print(object: any): void {
    if (this.enabled) {
      console.log(object);
    }
  }
}

export default new Debugger();



/** WEBPACK FOOTER **
 ** ./src/utility/Debugger.ts
 **/